export const showSalesclerks = (state) => state.salesClerks
